// Tap to talk's two calls — T57b (12 Sep 2026) and T66 (13 Sep 2026): the URL Amazon Transcribe's
// socket is opened with, signed by the service for one dictation (services/bff/src/speech.ts), and
// her voice — one answer's text to the service, its audio back. Neither a query nor a mutation:
// nothing is cached and nothing refetched, because each tap needs a fresh URL — one opens one
// stream, and only for ninety seconds — and each answer is said once.
import type {
  DictationResponse,
  FinishedRequest,
  FinishedResponse,
  SpeechRequest,
} from '@vera/bff';
import { API_PREFIX, type RequestFn } from './core.ts';

export const speechApi = (request: RequestFn) => ({
  dictation: () => request<DictationResponse>(`${API_PREFIX}/dictation`),
  /**
   * T451c: a model's read of whether the words so far are a finished thought (silence.ts). Null
   * when it cannot say; a failed request is null too, so the fixed silence ends the listen.
   */
  finished: async (text: string, mode: FinishedRequest['mode']): Promise<boolean | null> => {
    try {
      const { finished } = await request<FinishedResponse>(`${API_PREFIX}/speech/finished`, {
        method: 'POST',
        body: { text, mode } satisfies FinishedRequest,
      });
      return finished;
    } catch {
      return null;
    }
  },
  /** The answer as Polly says it: MP3 bytes, played from a blob (src/speech.ts `pollySpeechOutput`). */
  say: (text: string) =>
    request<ArrayBuffer>(`${API_PREFIX}/speech`, {
      method: 'POST',
      body: { text } satisfies SpeechRequest,
      binary: true,
    }),
});
